import React, {useEffect, useState} from "react";
import { Identification } from "../../Identification";
import {getListeIdentificationSommaire} from "../../../../../data/rateau";
import {Divider} from "antd";
import {ModalTitle} from "../../../../modals/modals.components";
import ModalAlert from "../../../../modals/Modal";
import ModalNavBarMenu from "../../../../modals/ModalNavBarMenu";
import {
    faFileArchive,
    faFileDownload,
    faFileText,
    faIdCard
} from "@fortawesome/free-solid-svg-icons";
import {IdentificationUser} from "../../IdentificationUser";
import {TraitementCycleDocument} from "./modals/TraitementCycleDocument";
import {ObservationGenerale} from "./modals/ObservationGenerale";
import {ListeModeleDocuments} from "./modals/ListeModeleDocuments";
import UserCycleIdentification from "../../UserCycleIdentification";

const CycleFyles = ({
       handleVisibility,
       mission,
       client,
       visible,
       codeSommaire,
       // setVisible
   }) => {
    const [activeTab, setActiveTab] = useState(0)
    const [loading, setLoading] = useState(false)
    const [date, setDate] = useState('');
    const [tache_id, setTache_id] = useState(null);
    const [intervention_id, setIntervention_id] = useState(null);
    const [user_id, setUser_id] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [heureEntree, setHeureEntree] = useState('');
    const [identifications, setIdentifications] = useState([]);
    const [observation, setObservation] = useState(null)
    const [modalId, setModalId] = useState(0)
    const [auth, setAuth] = useState(false);

    useEffect(()=> {
        if(activeTab === 0){
            getListeIdentificationSommaire(mission.id, codeSommaire)
                .then((res) => {
                    setIdentifications(res.result)
                })
        }
    }, [activeTab, codeSommaire, mission])

    const handleModalOpen = (value, modal) => {
        setLoading(true)
        setTimeout(() => {
            setIsModalOpen(prevState => !prevState);

            if(modal){
                setModalId(modal)
                setAuth(true)
            }
            else{
                setTache_id(value.tache_id);
                setIntervention_id(value.intervention_id);
                setAuth(true)
            }
            setLoading(false)
        }, 1000)
    };

    const steps = [
        {
            title: "IDENTIFICATIONS",
            icon: faIdCard,
        },
        {
            title: "MODELE DOCUMENT",
            icon: faFileDownload,
        },
        {
            title: "TRAITEMENT CYCLE",
            icon: faFileArchive,
        },
        {
            title: "OBSERVATION",
            icon: faFileText,
        }
    ]

    return (
        <>
            <ModalAlert
                closeModal={handleVisibility}
                show={visible}
                title={<ModalTitle> {codeSommaire || ""} - TRAITEMENT CYCLE </ModalTitle>}
                footer={[]}
                modalStyles={{ top: 15 }}
                width={1400}
            >
                <Divider/>
                <ModalNavBarMenu
                    setActiveTab={setActiveTab}
                    activeTab={activeTab}
                    steps={steps}
                    setLoading={setLoading}
                    loading={loading}
                    auth={auth}
                />
                {activeTab === 0 && (
                    <UserCycleIdentification
                    setDate={setDate}
                    dateDebut={date}
                    setTache_id={setTache_id}
                    setIntervention_id={setIntervention_id}
                    setHeureEntree={setHeureEntree}
                    setUser_id={setUser_id}
                    mission={mission}
                    prev={null}
                    loading={loading}
                    codeSommaire={codeSommaire}
                    setIsAuthorized={setAuth}
                    isAuthorized={auth}
                    setActiveStep={setActiveTab}
                />
                )}
                {activeTab === 1 && (
                    <ListeModeleDocuments
                        handleVisibility={handleModalOpen}
                        data={client}
                        mission={mission}
                        visible={isModalOpen}
                        client={client}
                    />
                )}
                {activeTab === 2 && (
                    <TraitementCycleDocument
                        mission={mission}
                        client={client}
                        codeSommaire={codeSommaire}
                        intervention_id={intervention_id}
                        date={date}
                        heureEntree={heureEntree}
                        tache_id={tache_id}
                        user_id={user_id}
                    />
                )}
                {activeTab === 3 && (
                    <ObservationGenerale
                        observation={observation}
                        setObservation={setObservation}
                    />
                )}

                {/* {(isModalOpen && modalId === 1) && <IdentificationUser
                    setDate={setDate}
                    setTache_id={setTache_id}
                    tache_id={tache_id}
                    setIntervention_id={setIntervention_id}
                    intervention_id={intervention_id}
                    setUser_id={setUser_id}
                    mission={mission}
                    visible={isModalOpen}
                    handleVisibility={handleVisibility}
                    handleValider={handleModalOpen}
                    setHeureEntree={setHeureEntree}
                    loading={loading}
                    setIsAuthorized={setAuth}
                    isAuthorized={auth}
                />} */}
            </ModalAlert>
        </>
    );
}

export {CycleFyles}